// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ae72cb48d783ae3351a9","655":"fca2e7b24a1a69272aad"}[chunkId] + ".js";
};